import { render, staticRenderFns } from "./select_prize.vue?vue&type=template&id=41cc960c&scoped=true"
import script from "./select_prize.vue?vue&type=script&lang=js"
export * from "./select_prize.vue?vue&type=script&lang=js"
import style0 from "./select_prize.vue?vue&type=style&index=0&id=41cc960c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41cc960c",
  null
  
)

export default component.exports